const BODY_LOCK_CLASS = 'no-scroll';
const ACTIVE_CLASS = 'active';

const OPEN_ATTR = 'data-popup-open';
const CLOSE_ATTR = 'data-popup-close';
const NAME_ATTR = 'data-popup-name';
const STATIC_ATTR = 'data-popup-static';

const CARD_SELECTOR = '.popup__card';
const CLOSE_SELECTOR = `.popup__close, [${CLOSE_ATTR}]`;

export class Popup {
	constructor() {
		this.stack = [];
		this.lastFocused = null;

		this.onDocClick = this.onDocClick.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	applyEvents() {
		document.addEventListener('click', this.onDocClick);
		document.addEventListener('keydown', this.onKeyDown);
	}

	getPopup(name) {
		if (!name) return null;
		return document.querySelector(`[${NAME_ATTR}="${CSS.escape(name)}"]`);
	}

	isOpen(name) {
		const el = this.getPopup(name);
		return !!(el && el.classList.contains(ACTIVE_CLASS));
	}

	open(name, trigger = null) {
		const el = this.getPopup(name);
		if (!el || el.classList.contains(ACTIVE_CLASS)) return;

		if (this.stack.length === 0) {
			this.lastFocused = document.activeElement;
			document.body.classList.add(BODY_LOCK_CLASS);
		}

		el.classList.add(ACTIVE_CLASS);
		this.stack.push(name);

		el.dispatchEvent(new CustomEvent('popup:open', { bubbles: true, detail: { name, trigger } }));
	}

	close(name) {
		const el = this.getPopup(name);
		if (!el || !el.classList.contains(ACTIVE_CLASS)) return;

		el.classList.remove(ACTIVE_CLASS);
		this.stack = this.stack.filter((n) => n !== name);

		if (this.stack.length === 0) {
			document.body.classList.remove(BODY_LOCK_CLASS);
			if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
				this.lastFocused.focus();
			}
			this.lastFocused = null;
		}

		el.dispatchEvent(new CustomEvent('popup:close', { bubbles: true, detail: { name } }));
	}

	toggle(name) {
		this.isOpen(name) ? this.close(name) : this.open(name);
	}

	closeAll() {
		[...this.stack].reverse().forEach((name) => this.close(name));
	}

	onDocClick(e) {
		const trigger = e.target.closest(`[${OPEN_ATTR}]`);
		if (trigger) {
			const name = trigger.getAttribute(OPEN_ATTR);
			if (name) {
				e.preventDefault();
				this.open(name, trigger);
				return;
			}
		}

		const closeBtn = e.target.closest(CLOSE_SELECTOR);
		if (closeBtn) {
			const targetName = closeBtn.getAttribute(CLOSE_ATTR);
			if (targetName && targetName !== CLOSE_ATTR && this.getPopup(targetName)) {
				e.preventDefault();
				this.close(targetName);
				return;
			}
			const popup = closeBtn.closest(`[${NAME_ATTR}]`);
			if (popup) {
				e.preventDefault();
				this.close(popup.getAttribute(NAME_ATTR));
				return;
			}
		}

		const activePopup = e.target.closest(`[${NAME_ATTR}].${ACTIVE_CLASS}`);
		if (activePopup && !activePopup.hasAttribute(STATIC_ATTR) && !e.target.closest(CARD_SELECTOR)) {
			this.close(activePopup.getAttribute(NAME_ATTR));
		}
	}

	onKeyDown(e) {
		if (e.key !== 'Escape' || this.stack.length === 0) return;
		const top = this.stack[this.stack.length - 1];
		const el = this.getPopup(top);
		if (el && !el.hasAttribute(STATIC_ATTR)) {
			e.preventDefault();
			this.close(top);
		}
	}
}
